<div class="curtain">
    <section class="component-modalDialog helpdesk">
        <header>
            Kontakt na helpdesk
            <a class="closeModalDialog fa fa-close" (click)="close()"></a>
        </header>
        <div class="contentContainer scrollable nativeScrollbar inside">
            <dl>
                <dt>
                    <span class="fa fa-comments"></span>
                    <a href="http://www.cleverassets.cz/helpdesk" target="_blank">cleverassets.cz/helpdesk</a>
                </dt>
                <dd>
                    Upřednostňovaný kanál pro řešení problémů.
                    Váš požadavek se díky zatřídění rychleji dostane ke kompetentním lidem k řešení.
                    Můžete sledovat jeho průběh a mít tak jistotu, že se na něj nezapomnělo.
                    Je nutné se zaregistrovat/přihlásit.
                </dd>

                <dt>
                    <span class="fa fa-phone"></span>
                    <span class="link">+420 539 002 892</span>
                </dt>
                <dd>
                    Telefon pro okamžité řešení závažných problémů.
                    <br>
                    K dispozici jsme v pracovních dnech od 8:30 do 15:30.
                </dd>

                <dt>
                    <span class="fa fa-envelope-o"></span>
                    <a href="mailto:podpora@cleverassets.cz">podpora&#64;cleverassets.cz</a>
                </dt>
                <dd>
                    E-mail pro případ, že by ostatní kanály nefungovaly.
                </dd>
            </dl>

            <div class="persons">
                <ul>
                    <li><img src="/assets/img/foto-martina-kratochvilova.jpg" alt="foto"> Martina Kratochvílová</li>
                    <li><img src="/assets/img/foto-iva-vseteckova.jpg" alt="foto"> Iva Všetečková</li>
                </ul>
            </div>

        </div>
        <footer>
            <a class="button-primary" (click)="close()">Zavřít</a>
        </footer>
    </section>
</div><!-- curtain -->